import {
  Instagram,
  Github,
  Linkedin,
  Mail,
  MessageCircle,
} from "lucide-react";

const SOCIALS = [
  { name: "Instagram", href: "https://instagram.com/egekoeln", icon: Instagram, testId: "footer-social-instagram" },
  { name: "WhatsApp", href: "https://wa.me/4915229290009", icon: MessageCircle, testId: "footer-social-whatsapp" },
  { name: "GitHub", href: "https://github.com/egeyildiz", icon: Github, testId: "footer-social-github" },
  { name: "LinkedIn", href: "https://linkedin.com/in/egeyildiz", icon: Linkedin, testId: "footer-social-linkedin" },
  { name: "E-Mail", href: "mailto:hi@ege.koeln", icon: Mail, testId: "footer-social-email" },
];

/**
 * Footer – social icons row, copyright, and legal placeholder links.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/[0.06] px-6 py-12 sm:px-10 md:px-16 lg:px-24"
    >
      <div className="mx-auto flex w-full max-w-5xl flex-col items-start justify-between gap-8 md:flex-row md:items-center">
        <div className="flex flex-wrap items-center gap-2">
          {SOCIALS.map((s) => {
            const Icon = s.icon;
            return (
              <a
                key={s.name}
                href={s.href}
                target={s.href.startsWith("http") ? "_blank" : undefined}
                rel="noopener noreferrer"
                aria-label={s.name}
                data-testid={s.testId}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/[0.08] bg-white/[0.02] text-zinc-400 transition-all duration-300 hover:-translate-y-0.5 hover:border-white/20 hover:text-[#FF4500]"
              >
                <Icon size={16} strokeWidth={1.75} />
              </a>
            );
          })}
        </div>

        <div className="flex flex-col items-start gap-4 md:items-end">
          <div className="flex items-center gap-6 text-sm">
            <a
              href="#imprint"
              onClick={(e) => e.preventDefault()}
              data-testid="imprint-link"
              className="text-zinc-500 transition-colors hover:text-zinc-200"
            >
              Impressum
            </a>
            <span className="h-1 w-1 rounded-full bg-zinc-700" />
            <a
              href="#privacy"
              onClick={(e) => e.preventDefault()}
              data-testid="privacy-link"
              className="text-zinc-500 transition-colors hover:text-zinc-200"
            >
              Datenschutz
            </a>
          </div>
          <p
            className="font-mono-label text-[10px] text-zinc-600"
            data-testid="footer-copyright"
          >
            © {year} Ege Yıldız · Alle Rechte vorbehalten
          </p>
        </div>
      </div>
    </footer>
  );
}
